var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavingHandSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9015 37.3226C45.7373 38.2433 46.4841 39.4483 46.1659 39.7665C45.8476 40.0847 44.8718 39.5077 44.125 38.7609C43.3783 38.0142 41.5962 45.9484 41.4223 46.3515C41.295 46.6527 39.216 49.0288 38.1298 51.2945C37.7691 52.0497 37.82 54.324 37.6843 54.4597C37.1369 55.0071 36.4496 54.9477 34.9518 53.6239C33.4583 52.3001 32.6819 60.1707 34.4639 61.4139C37.5103 63.5396 43.6074 71.9958 51.6562 71.9958C60.9694 71.9958 69.5953 62.2794 69.5953 55.1471C69.5953 48.019 67.5035 45.312 67.6393 39.3337C67.7538 34.2719 71.4325 31.8577 71.4325 29.3289C71.4325 27.2032 68.2715 26.6855 67.2362 26.6855C65.3948 26.6855 60.6809 29.0446 60.6809 35.252C60.6809 37.6663 59.9893 39.8514 57.5199 39.8514C55.0506 39.8514 52.2884 36.457 50.6209 33.8137",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4412 29.3289C71.4412 28.1706 70.5077 27.4917 69.4852 27.1099C70.7071 31.1661 64.4998 31.3443 64.4998 45.172C64.4998 58.9997 56.4509 63.022 53.116 63.7136C49.7811 64.4052 43.9046 64.6046 39.4326 59.1143C38.0579 57.4298 36.1952 55.5969 34.1289 53.8657C33.2549 55.3296 33.0682 60.4338 34.4726 61.4139C37.519 63.5396 43.6161 71.9958 51.6649 71.9958C60.9781 71.9958 69.604 62.2795 69.604 55.1471C69.604 48.019 67.5122 45.312 67.648 39.3337C67.7583 34.2762 71.4412 31.862 71.4412 29.3289Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9561 53.6237C33.4626 52.2999 29.924 48.5364 27.6244 46.695C25.3247 44.8536 23.3136 44.879 21.9304 46.9072C20.5514 48.9353 24.5737 52.5036 25.4944 53.4243C26.9031 54.8329 32.6819 60.1705 34.464 61.418",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4223 46.3513C41.2484 46.7543 40.0773 47.0301 37.7437 44.4929C35.9617 42.5539 31.1884 36.9787 28.3711 34.4456C25.5538 31.9169 23.3687 30.8816 21.5273 32.2011C19.6858 33.5207 20.7338 36.2786 22.7917 38.5825C25.3374 41.4295 28.265 44.3316 31.0696 47.1192C33.2632 49.3001 38.2274 53.9037 37.6801 54.451",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6254 33.8138C48.9579 31.1704 42.1141 22.6591 40.4466 20.2449C38.7791 17.8307 36.5346 17.8307 34.9859 18.9211C33.433 20.0115 32.9748 22.1967 36.4667 26.8427C38.6688 29.7703 40.506 32.4688 44.9059 37.3227L50.0229 36.9663L50.6254 33.8138Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.125 38.761C43.3782 38.0142 36.7678 30.1775 35.27 28.4973C32.4654 25.3491 28.9141 18.6071 24.6754 21.6111C22.4479 23.1895 23.6529 25.4764 24.2893 26.3971C24.9215 27.3178 33.1443 36.805 33.9504 37.6111C34.7566 38.4173 41.5962 45.9485 41.4265 46.3516",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0738 47.1283C33.1443 49.1861 37.68 53.3993 37.7267 54.3285C38.3801 53.306 37.1836 50.2765 35.9192 49.2116C28.6171 43.0593 21.5569 33.1436 20.6617 33.4406C20.2755 34.8832 21.2514 36.8646 22.7959 38.5915C25.3374 41.4343 28.265 44.3407 31.0738 47.1283Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9015 37.3225C45.7034 38.205 46.4205 39.3549 46.1956 39.724C48.8644 37.5771 43.2213 31.2763 40.0264 27.4917C37.5528 24.564 36.8824 20.8387 35.1088 18.8403C35.0664 18.8658 35.024 18.8955 34.9815 18.9252C33.4286 20.0156 32.9704 22.2007 36.4623 26.8467C38.6686 29.7744 40.5016 32.4686 44.9015 37.3225Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9505 37.6107C34.7567 38.4169 41.5963 45.9481 41.4265 46.3512C43.5395 43.5041 35.3464 35.1371 31.3793 30.9112C27.9383 27.2453 27.3485 24.0376 23.9924 22.2344C22.7449 23.7406 23.7378 25.5905 24.2894 26.3967C24.9216 27.3174 33.1444 36.8046 33.9505 37.6107Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2696 46.5169C41.0278 46.6654 40.5356 46.6781 39.7761 46.2368C40.3404 46.6993 40.8666 46.8733 41.2696 46.5169Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5044 61.6174C26.4535 61.6174 26.4025 61.6089 26.3516 61.5962C21.1031 59.9966 15.4176 54.2601 14.1829 49.3214C14.115 49.0456 14.2805 48.7613 14.5605 48.6934C14.8363 48.6255 15.1206 48.791 15.1885 49.071C16.3256 53.6237 21.7905 59.1225 26.6529 60.6075C26.9244 60.6924 27.0814 60.9809 26.9966 61.2525C26.9287 61.4731 26.725 61.6174 26.5044 61.6174Z",
    fill: "#955500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0034 68.1304C28.9652 68.1304 28.927 68.1262 28.8846 68.1177C24.5398 67.1079 19.495 63.862 15.0399 59.216C10.8734 54.8713 8.17488 50.2507 8.00092 47.1576C7.98395 46.8733 8.20458 46.6273 8.48885 46.6103C8.77313 46.5933 9.01921 46.814 9.03619 47.0982C9.19317 49.9113 11.845 54.3876 15.7867 58.499C20.106 63.005 24.9684 66.1405 29.1222 67.1079C29.4022 67.1715 29.5719 67.4515 29.5083 67.7273C29.4531 67.9692 29.241 68.1304 29.0034 68.1304Z",
    fill: "#955500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2576 22.8334C51.0284 22.8334 50.8205 22.6806 50.7569 22.4473C50.0271 19.6851 46.7219 15.718 43.7094 14.9373C43.4336 14.8651 43.2681 14.5851 43.336 14.3051C43.4081 14.0293 43.6882 13.8638 43.9682 13.9317C47.3626 14.81 50.9393 19.0869 51.7582 22.18C51.8303 22.4557 51.6649 22.74 51.3891 22.8122C51.3467 22.8291 51.3 22.8334 51.2576 22.8334Z",
    fill: "#955500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7832 23.7539C57.5541 23.7539 57.3419 23.5969 57.2825 23.3635C55.3393 15.7262 48.0881 9.76918 43.9513 9.02667C43.6712 8.97576 43.4846 8.70844 43.5355 8.42417C43.5864 8.14414 43.8537 7.95745 44.138 8.00837C48.6524 8.81877 56.2176 14.9583 58.2924 23.1089C58.3645 23.3847 58.1948 23.669 57.919 23.7369C57.8681 23.7496 57.8256 23.7539 57.7832 23.7539Z",
    fill: "#955500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7328 27.5472C69.4894 27.2332 69.7991 27.4326 69.4851 27.1102C68.628 26.7919 67.7158 26.6816 67.2406 26.6816C65.3992 26.6816 60.6853 29.0407 60.6853 35.2481C60.6853 37.6623 59.9937 39.8474 57.5243 39.8474C56.5485 39.8474 55.5302 39.3171 54.55 38.5194C58.8906 43.3266 62.2976 38.7994 62.8153 35.6936C63.3329 32.5878 62.5819 28.4764 67.7328 27.5472Z",
    fill: "url(#paint10_radial)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4513 19.3921C33.3779 20.6056 33.4118 22.7864 36.4625 26.8427C38.6645 29.7703 40.5017 32.4688 44.9017 37.3227C45.7375 38.2434 46.4843 39.4484 46.166 39.7666C46.9001 34.7345 39.7423 29.7915 37.4129 25.9941C35.5715 22.9901 35.2023 21.2165 34.4513 19.3921Z",
    fill: "url(#paint11_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9507 37.611C34.7569 38.4171 41.5964 45.9483 41.4267 46.3514C42.9372 45.2737 41.9062 43.5977 39.5726 41.2641C34.7908 36.4824 28.1336 30.0543 25.4564 24.7634C25.2018 24.2627 24.7351 23.8936 24.1792 23.8215C22.7366 23.6348 23.8059 25.6969 24.2896 26.4012C24.9218 27.3176 33.1445 36.8048 33.9507 37.611Z",
    fill: "url(#paint12_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.796 38.5869C25.3418 41.4339 28.2694 44.3361 31.074 47.1237C33.2676 49.3046 38.2318 53.9081 37.6845 54.4555C40.7606 51.8673 26.4704 42.5032 20.6576 33.436C20.2757 34.8786 21.2516 36.8601 22.796 38.5869Z",
    fill: "url(#paint13_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0522 54.9773C37.3449 54.8627 37.4977 54.7269 37.5443 54.5784C37.0182 54.9858 36.3224 54.8373 34.9519 53.6238C33.4584 52.3 29.9198 48.5365 27.6202 46.6951C26.6103 45.8847 25.6557 45.4392 24.7859 45.3628C26.0333 46.1392 25.4563 46.4235 28.2269 48.5492C29.7119 49.6863 35.1556 55.724 37.0522 54.9773Z",
    fill: "url(#paint14_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4329 41.1748C35.4525 43.6314 39.39 47.6919 41.1593 46.5675C40.6713 46.733 39.5597 46.4657 37.7437 44.4885C35.9617 42.5495 31.1884 36.9743 28.3711 34.4413C26.0884 32.3919 24.2215 31.3227 22.6177 31.6961C27.2934 33.2405 31.5193 38.8496 33.4329 41.1748Z",
    fill: "url(#paint15_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.618 30.5932C38.8426 34.0978 43.6202 41.0477 46.0471 39.8343C45.6483 39.9573 44.7955 39.4269 44.1293 38.7608C43.3826 38.014 36.7721 30.1774 35.2743 28.4972C33.3311 26.3163 31.0314 22.4128 28.3923 21.2163C31.0526 23.3123 33.0044 27.7547 35.618 30.5932Z",
    fill: "url(#paint16_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5499 38.5232C53.0437 37.2927 51.635 35.4174 50.6252 33.8135C48.9577 31.1702 42.1139 22.6589 40.4464 20.2447C39.9373 19.5107 39.3772 18.9973 38.7959 18.6748C39.5724 19.7907 40.0094 21.3818 41.7659 23.3505C44.5832 26.5115 48.2619 32.2055 49.5305 34.1615C50.7949 36.1132 52.8357 40.2373 54.5499 38.5232Z",
    fill: "url(#paint17_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.774 66.586C62.726 64.0403 61.1986 62.4916 58.988 63.9469C52.9588 67.9141 46.0216 66.5775 37.3279 59.547C29.5718 53.276 25.5622 48.7912 21.7903 47.1704C20.8865 49.2325 24.6161 52.5419 25.4986 53.4245C26.9072 54.8331 32.6861 60.1707 34.4681 61.4181C37.5145 63.5438 43.6116 72 51.6605 72C56.1537 71.9957 60.49 69.73 63.774 66.586Z",
    fill: "url(#paint18_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6437 39.3336C67.7582 34.2718 71.4368 31.8576 71.4368 29.3288C71.4368 28.5821 71.0507 28.039 70.4991 27.6401C71.1738 29.6089 69.5699 31.3569 67.1812 34.3312C64.593 37.5516 64.0202 42.554 65.8022 47.5564C67.5842 52.5588 65.344 59.4578 61.7205 61.6429C58.0971 63.8281 53.2856 73.4298 39.5046 62.5806C39.5003 62.5764 39.5003 62.5764 39.4961 62.5721C38.656 61.7914 37.8244 61.0998 36.98 60.578C31.1587 56.9715 27.845 53.7299 25.3375 51.0059C24.8453 50.4713 23.5215 48.4135 21.9431 49.0924C22.7323 50.8786 24.858 52.7837 25.4944 53.4244C26.9031 54.833 32.682 60.1706 34.464 61.4181C34.6973 61.5793 34.9477 61.7787 35.215 62.0078C35.2829 62.0672 35.355 62.1266 35.4271 62.1903C35.4441 62.2073 35.4653 62.2242 35.4823 62.2412C35.529 62.2836 35.5714 62.3218 35.6181 62.3642C35.6265 62.3727 35.6393 62.3812 35.6478 62.3939C37.4552 64.0359 39.9458 66.7557 42.9965 68.8814C42.9965 68.8814 43.0007 68.8814 43.0007 68.8856C43.268 69.0723 43.5396 69.2547 43.8154 69.4329C43.8196 69.4372 43.8239 69.4372 43.8281 69.4414C44.1039 69.6154 44.3797 69.7851 44.664 69.9463C44.6682 69.9463 44.6682 69.9506 44.6724 69.9506C46.7854 71.1641 49.1233 71.9999 51.6521 71.9999C60.9653 71.9999 69.5911 62.2836 69.5911 55.1513C69.5996 48.0189 67.5079 45.3119 67.6437 39.3336Z",
    fill: "url(#paint19_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 65.0719,
    y1: 73.8383,
    x2: 57.3957,
    y2: 55.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 70.5878,
    y1: 66.0874,
    x2: 54.4877,
    y2: 46.8823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.5656,
    y1: 48.5439,
    x2: 33.0531,
    y2: 55.5302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.111,
    y1: 30.0526,
    x2: 36.7574,
    y2: 47.4752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 38.091,
    y1: 21.833,
    x2: 47.7511,
    y2: 37.0131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 28.119,
    y1: 24.3547,
    x2: 41.2291,
    y2: 42.0648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 32.8899,
    y1: 40.3992,
    x2: 27.3872,
    y2: 45.5829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 43.711,
    y1: 26.4916,
    x2: 35.4309,
    y2: 33.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 36.0946,
    y1: 31.8169,
    x2: 24.7096,
    y2: 40.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 44.5759,
    y1: 43.4182,
    x2: 33.1907,
    y2: 51.7414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C492"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4901 29.896) scale(13.6651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C492"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 45.2264,
    y1: 25.0238,
    x2: 38.1538,
    y2: 31.5788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 39.8106,
    y1: 28.5764,
    x2: 30.4955,
    y2: 36.9715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 36.6625,
    y1: 37.6567,
    x2: 25.1624,
    y2: 47.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 24.1141,
    y1: 44.6741,
    x2: 37.4829,
    y2: 55.5417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 26.6728,
    y1: 31.2032,
    x2: 37.1091,
    y2: 47.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 34.8476,
    y1: 32.3372,
    x2: 37.7801,
    y2: 30.0947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 46.9555,
    y1: 27.0988,
    x2: 41.5504,
    y2: 55.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#F0C492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 40.3929,
    y1: 59.0772,
    x2: 34.5278,
    y2: 64.4679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C492"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4847 45.5739) rotate(48.1397) scale(39.6158 35.9612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6134,
    stopColor: "#F0C492",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AF74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHandSvgrepoCom);
export default __webpack_public_path__ + "static/media/waving-hand-svgrepo-com.c06027aa9c46c1cd1e4a70a6c224f1c6.svg";
export { ForwardRef as ReactComponent };